import clsx from 'clsx'
import React from 'react'
import { Control } from 'react-hook-form'

import s from './styles.module.scss'

import { PdfTypeEnum } from '../../../../../../../../lib/graphql'
import { usePdfContext } from '../../../../../../../contexts'
import { Checkbox } from '../../../../../../../forms'

export interface PdfCheckboxTextInterface {
  pdfType?: PdfTypeEnum
  label: string
  url?: string
}

export type ModalClientRequestLinkType = {
  label: string
  className?: string
}

export const LinkFormated = ({
  label,
  onClick,
}: {
  label: string
  onClick: () => void
}) => (
  <span
    className={s.link}
    onClick={(e) => {
      e.stopPropagation()
      onClick()
    }}
  >
    {label}
  </span>
)

const PdfCheckbox = ({
  control,
  name,
  clientProposalId,
  clientRequestId,
  setIsLoading,
  pdfCheckboxText,
  className,
}: {
  control: Control<any, any>
  name: string
  clientProposalId: string
  clientRequestId: string
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  pdfCheckboxText: PdfCheckboxTextInterface[]
  className?: string
}) => {
  const { useGetPdfsByClientProposalIdQuery, getPdfs } = usePdfContext()

  const { data } = useGetPdfsByClientProposalIdQuery({
    clientRequestId,
    clientProposalId,
    pdfTypes: pdfCheckboxText
      .filter((pdf) => pdf.pdfType)
      .map((pdf) => pdf.pdfType) as PdfTypeEnum[],
  })

  const onClickPdf = async (pdfType: PdfTypeEnum) => {
    const pdf = data.find((pdf) => pdf.pdfType === pdfType)
    if (pdf?.url) {
      window.open(pdf.url, '_blank')
      return
    }

    try {
      setIsLoading(true)

      const pdfs = await getPdfs([pdfType], true)

      setIsLoading(false)
      if (pdfs.length > 0 && pdfs[0].url) {
        const isChrome =
          /Chrome/.test(navigator.userAgent) &&
          /Google Inc/.test(navigator.vendor)
        if (isChrome) {
          const link = document.createElement('a')

          link.href = pdfs[0].url
          link.download = pdfs[0].filename

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          window.open(pdfs[0].url)
        }
      }
    } catch {
      setIsLoading(false)
    }
  }

  return (
    <Checkbox
      className={clsx(s.checkboxContainer, className)}
      control={control}
      label={
        <label htmlFor='checkbox'>
          <span className={s.checkboxLabel}>
            {pdfCheckboxText.map(({ pdfType, label, url }, index) => {
              if (pdfType) {
                return (
                  <span key={index}>
                    {' '}
                    <LinkFormated
                      label={label}
                      onClick={() => onClickPdf(pdfType)}
                    />{' '}
                  </span>
                )
              } else if (url) {
                return (
                  <span key={index}>
                    {' '}
                    <LinkFormated
                      label={label}
                      onClick={() => window.open(url, '_blank')}
                      key={index}
                    />{' '}
                  </span>
                )
              }

              return label
            })}
          </span>
        </label>
      }
      rules={{ required: true }}
      name={name}
    />
  )
}

export default PdfCheckbox
